import { render, staticRenderFns } from "./SaleHeaderBar.vue?vue&type=template&id=3bd87a61&scoped=true"
import script from "./SaleHeaderBar.vue?vue&type=script&lang=js"
export * from "./SaleHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./SaleHeaderBar.vue?vue&type=style&index=0&id=3bd87a61&prod&scoped=true&lang=css"
import style1 from "./SaleHeaderBar.vue?vue&type=style&index=1&id=3bd87a61&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd87a61",
  null
  
)

export default component.exports